// Hooplandia Widgets

import cardWidgetQuickLinks from "./js/widgets/cardWidgetQuickLinks.js";
import cardWidgetLogoDates from "./js/widgets/cardWidgetLogoDates.js";
import mainSlider from "./js/widgets/mainSlider.js";
import cardWidgetExploreButtons from "./js/widgets/cardWidgetExploreButtons.js";
import cardWidgetMoreBigE from "./js/widgets/cardWidgetMoreBigE.js";
import cardWidgetLineup from "./js/widgets/cardWidgetLineup.js";
import cardWidgetFooterLogoSlogan from "./js/widgets/cardWidgetFooterLogoSlogan.js";
import cssSponsors from "./js/widgets/cssSponsors.js";

import "./js/siteInfoBanner.js";
import microModal from "./js/microModal";
// Custom theme scripts

import "./js/localjs.js";

import { themeController } from "./js/subpages/themeController.js";



$(document).ready(function () {
  microModal();
  setTimeout(() => {
    $(".header").css("opacity", "1");
  }, 200);

  themeController();
});

// Initialize homepage widgets
if (globalThis.location.pathname === "/") {
  $(document).ready(function () {
    mainSlider();
    cardWidgetExploreButtons();
    cardWidgetMoreBigE();
    cardWidgetLineup();
    cssSponsors();
  });
}

// Initialize site-wide widgets
$(document).ready(function () {
  cardWidgetFooterLogoSlogan();
  cardWidgetQuickLinks();
  cardWidgetLogoDates();
});
